module.exports = __webpack_public_path__ + "flyer_background_ferris_wheel_036-777befd89f6464818fd28bfdd460181d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_ferris_wheel_036.jpg
// module id = 1641
// module chunks = 1